export enum FormFieldVisibility {
  PUBLIC = 'public',
  CONNECTED = 'connected',
  PRIVATE = 'private',
}
